import axios from "axios";
import $axios from "../api/accessor";
import { $api } from "../api/api";

export const PopupServices = {
  async getPopUp() {
    const response = await $axios.get($api("get_popUp")).catch((err) => {
      return err.response;
    });

    const isActive = response?.data?.status === 1;
    return {
      data: response?.data.data ?? [],
      isActive: isActive,
      status: response?.status,
    };
  },

  async closePopUp(currentVersion: string | null) {
    const response = await $axios
      .post(
        $api("popup_close"),
        { popup_version: currentVersion },
        {
          headers: { "X-Popup-Version": currentVersion ?? "" },
        }
      )
      .catch((err) => err.response);

    const newVersion = response?.headers?.["x-popup-version"];

    return {
      data: response?.data,
      status: response?.status,
      newVersion: newVersion,
    };
  },

  async checkPopupStatus(popupVersion: string | null) {
    try {
      const response = await $axios.get($api("check_status"), {
        headers: {
          "X-Popup-Version": popupVersion || "",
        },
      });

      return {
        data: response.data,
        status: response.status,
        version: response.headers?.["x-popup-version"] ?? null,
      };
    } catch (error: any) {
      console.error("Error:", error);
      return {
        data: error.response?.data,
        status: error.response?.status,
        version: null,
      };
    }
  },
};
